import {
  query,
  mutate,
} from '../../core/createApolloClient/createApolloClient.client';
import { getp } from '../../helpers/getProp';
import gql from 'graphql-tag';

const mutation = gql`
  mutation sendMessage(
    $threadId: Int!
    $reservationId: Int
    $content: String
    $eventName: String
    $startDate: String
    $endDate: String
    $pickupTime: String
    $returnTime: String
    $pickupCity: String
    $pickupState: String
    $pickupStreet: String
    $pickupZipcode: String
    $pickupBuildingName: String
    $returnCity: String
    $returnState: String
    $returnStreet: String
    $returnZipcode: String
    $returnBuildingName: String
  ) {
    sendMessage(
      threadId: $threadId
      reservationId: $reservationId
      content: $content
      eventName: $eventName
      startDate: $startDate
      endDate: $endDate
      pickupTime: $pickupTime
      returnTime: $returnTime
      pickupCity: $pickupCity
      pickupState: $pickupState
      pickupStreet: $pickupStreet
      pickupZipcode: $pickupZipcode
      pickupBuildingName: $pickupBuildingName
      returnCity: $returnCity
      returnState: $returnState
      returnStreet: $returnStreet
      returnZipcode: $returnZipcode
      returnBuildingName: $returnBuildingName
    ) {
      id
    }
  }
`;

const approveReservationM = async function({
  pickupTime,
  returnTime,
  pickupDay,
  returnDay,
  pickupAddress,
  returnAddress,
  id,
  threadId,
}) {
  const results = await mutate(mutation, {
    threadId,
    content: '',
    eventName: 'approved',
    startDate: pickupDay,
    endDate: returnDay,
    reservationId: id,
    pickupTime,
    returnTime,
    pickupCity: pickupAddress.city.value,
    pickupState: pickupAddress.state.value,
    pickupStreet: pickupAddress.street.value,
    pickupZipcode: pickupAddress.zipcode.value,
    pickupBuildingName: pickupAddress.buildingName.value,
    returnCity: returnAddress.city.value,
    returnState: returnAddress.state.value,
    returnStreet: returnAddress.street.value,
    returnZipcode: returnAddress.zipcode.value,
    returnBuildingName: returnAddress.buildingName.value,
  });
  const success = getp(results, 'data.sendMessage.id');
  if (success) {
    return true;
  } else {
    console.log(
      'ERR - approveReservationM - Mutation failed',
      results.data.status,
    );
    return false;
  }
};

export default approveReservationM;



// WEBPACK FOOTER //
// ./src/mobxStores/Inbox/approveReservationMFn.js